import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { PosModalNotifiy } from 'app/views/pos/componentes/modais/pos-modal-notifiy/pos-modal-notifiy';
import { Utilizadores } from 'app/shared/models/aplicacao/utilizadores';
import { PosArtigoModel } from '../modelos/pos-artigo.model';
import { Util } from '../../../shared/models/generico/util';
import { ItemDocumento } from '../../../shared/models/item-documento';
import { FormBuilder } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PosUtilityService {
  artigosParaVenda$ =  new BehaviorSubject<any[]>([]);
  terminalEmUso$ = new BehaviorSubject<any>(null);
  mostrarTecladoAlpha$ = new BehaviorSubject<boolean>(false);
  mostrarTelaLoja$ = new BehaviorSubject<boolean>(true);
  terminalOperator$ = new BehaviorSubject<Utilizadores>(null);
  localTerminalKey  = 'pos_terminal';

 public static isNum(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(parseFloat(value));
  }

  
  constructor(private  snack: MatSnackBar, private dialog: MatDialog, private fb: FormBuilder) { }

  openFullScreen(fullScreeOpen: boolean) {
    const body = document.querySelector('body');
    if (body) {
      if (fullScreeOpen) {
        body.requestFullscreen({navigationUI: 'hide'});
      } else {
        document.exitFullscreen();
      }
    }
  }

  getPOSOperatorFromLocal() {
    if (localStorage.getItem('_utilizador')) {
      this.terminalOperator$.next(JSON.parse(localStorage.getItem('_utilizador')));
    }
  }
  getLocalTerminal() {
    return localStorage.getItem(this.localTerminalKey);
  }
  setLocalTerminal(value: any) {
     localStorage.setItem(this.localTerminalKey, JSON.stringify(value));
  }
  clearLocalTerminal() {
    localStorage.removeItem(this.localTerminalKey);
  }

  posSnackToast(mensagem: string, res?: boolean, duracao?: number) {
    this.snack.open(
      mensagem,
      res ? '✔️' : '❌',
      {
        verticalPosition: 'top',
        duration: duracao <= 0 || !duracao ? 50000 : duracao,
        panelClass: 'pos-notify'
      }
    );
  }

  posDialogToast(titulo?: string, info?: string, res?: boolean) {
    this.dialog.open(
      PosModalNotifiy, {
        width: '30vw',
        panelClass: 'pos-dialog-toast',
        data: {titulo, info, res},
      }
    );
  }

   criarItemControl(item?: ItemDocumento) {
    return this.fb.group({
      idArtigo: item && item.idArtigo ? item.idArtigo : null,
      codArtigo: item && item.codArtigo ? item.codArtigo : null,
      descricao: item && item.descricao ? item.descricao : '',
      idImposto: item && item.idImposto ? item.idImposto : null,
      taxaImposto: item && item.taxaImposto ? item.taxaImposto : null,
      idIva: item && item.idImposto ? item.idImposto : null,
      precoItem: item && item.preco ? item.preco : 0,
      quantidade: [item?.quantidade ? Util.convertToFloat3Casas(item.quantidade) : Util.convertToFloat3Casas(1)],
      subTotal: item && item.subTotal ? item.subTotal : 0,
      totalGeral: item && item.totalGeral ? item.totalGeral : 0,
      subTotalIliq: item && item.subTotalIliq ? item.subTotalIliq : 0,
      total: item && item.total ? item.total : 0,
      descontoPerc: item && item.descontoPerc ? item.descontoPerc : 0,
      desconto: item && item.desconto ? item.desconto : 0,
      unidadeMedida: '',
      codUnidade: item && item.codUnidade ? item.codUnidade : 'UN',
      idArmazem: 0
    });
  }

}
